/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Delete_Terms_TitleInputs */

const en_knp_terms_delete_terms_title = /** @type {(inputs: Knp_Terms_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Terms?`)
};

const fr_knp_terms_delete_terms_title = /** @type {(inputs: Knp_Terms_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les termes ?`)
};

const de_knp_terms_delete_terms_title = /** @type {(inputs: Knp_Terms_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsbedingungen löschen?`)
};

const it_knp_terms_delete_terms_title = /** @type {(inputs: Knp_Terms_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare i termini?`)
};

const ru_knp_terms_delete_terms_title = /** @type {(inputs: Knp_Terms_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить условия?`)
};

const es_knp_terms_delete_terms_title = /** @type {(inputs: Knp_Terms_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar términos?`)
};

const zh_cn2_knp_terms_delete_terms_title = /** @type {(inputs: Knp_Terms_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除条款？`)
};

const ja_knp_terms_delete_terms_title = /** @type {(inputs: Knp_Terms_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用規約を削除しますか?`)
};

const hi_knp_terms_delete_terms_title = /** @type {(inputs: Knp_Terms_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शर्तें हटाएं?`)
};

const pt_pt2_knp_terms_delete_terms_title = /** @type {(inputs: Knp_Terms_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir termos?`)
};

/**
* | output |
* | --- |
* | "Delete Terms?" |
*
* @param {Knp_Terms_Delete_Terms_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_delete_terms_title = /** @type {((inputs?: Knp_Terms_Delete_Terms_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Delete_Terms_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_delete_terms_title(inputs)
	if (locale === "de") return de_knp_terms_delete_terms_title(inputs)
	if (locale === "it") return it_knp_terms_delete_terms_title(inputs)
	if (locale === "ru") return ru_knp_terms_delete_terms_title(inputs)
	if (locale === "es") return es_knp_terms_delete_terms_title(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_delete_terms_title(inputs)
	if (locale === "ja") return ja_knp_terms_delete_terms_title(inputs)
	if (locale === "hi") return hi_knp_terms_delete_terms_title(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_delete_terms_title(inputs)
	return en_knp_terms_delete_terms_title(inputs)
});